import { useQuery } from '@tanstack/react-query';
import { QUERY_ANNOUNCEMENTS_KEY } from '@web-app/hooks/consts';

export interface ActiveAnnouncement {
  id: string;
  title: string;
  description: string | null;
  priority: 'info' | 'warning' | 'critical';
  route: string | null;
  publishedAt: string | null;
}

interface AnnouncementsResponse {
  announcements: ActiveAnnouncement[];
}

const fetchAnnouncements = async (): Promise<ActiveAnnouncement[]> => {
  const response = await fetch('/api/announcements');

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.error || 'Failed to fetch announcements');
  }

  const data: AnnouncementsResponse = await response.json();
  return data.announcements;
};

export const useAnnouncements = () => {
  return useQuery<ActiveAnnouncement[], Error>({
    queryKey: [QUERY_ANNOUNCEMENTS_KEY],
    queryFn: fetchAnnouncements,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
};
